<template>
  <div class="loader_short">
    <div class="loader_short__header">
      <div class="loader_short__user">
        <div class="loader_short__avatar shimmer" />
      </div>
    </div>
    <div class="loader_short__img shimmer" />
    <div class="loader_short__username shimmer" />
  </div>
</template>

<script>
export default {
  name: "PostShortLoader",
};
</script>

<style scoped>
.loader_short {
  background: var(--loader-box-color);
  border-radius: 31px;
  overflow: hidden;
  margin-bottom: 20px;
  width: 100%;
  height: 300px;
  display: flex;
  padding: 12px;
  box-sizing: border-box;
}

.loader_short__header {
  display: flex;
  align-items: flex-start;
  height: 100%;
}

.loader_short__img {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 195px;
  height: 100%;
  margin-left: 12px;
  background: var(--loader-color);
  border-radius: 15px;
  position: relative;
}

.loader_short__user {
  display: flex;
  align-items: center;
  gap: 12px;
}

.loader_short__avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: var(--loader-color);
}

.loader_short__username {
  width: 88px;
  height: 29px;
  border-radius: 25px;
  margin-left: 12px;
  background: var(--loader-color);
}

.shimmer {
  position: relative;
  overflow: hidden;
}

.shimmer::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    90deg,
    transparent,
    var(--loader-animation-color),
    transparent
  );
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(100%);
  }
}
</style>
